import React from "react";
import { useTranslation } from "react-i18next";
import PageHeader from "../../components/Elements/PageHeader/PageHeader";

import OffersFilter from "../../components/Offers/OffersFilter/OffersFilter";
import OffersList from "../../components/Offers/OffersList/OffersList";
import { OffersProvider } from "../../context/OffersContext";

import "./Offers.css";

const Offers = () => {
  const { t } = useTranslation();
  return (
    <div className="page">
      <PageHeader title={t("offers.title")} description={t("offers.description")} />
      <div className="page-content">
        <OffersProvider>
          <div className="offers-layout">
            <section className="offers-sidebar shadow rounded">
              <OffersFilter />
            </section>
            <section className="offers-main shadow rounded">
              <OffersList />
            </section>
          </div>
        </OffersProvider>
      </div>
    </div>
  );
};

export default Offers;
